import React from 'react';
import PropTypes from 'prop-types';

import SEO from './SEO';
import Instagram from '../svg/icons/instagram.svg';
import {
  footer,
  contact,
  social,
  socialContainer,
  contactContainer,
  address,
  copy,
} from './Layout.module.css';

const propTypes = {
  pageTitle: PropTypes.string.isRequired,
  copyright: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showFooter: PropTypes.bool,
};

const Layout = (props) => {
  const {
    pageTitle,
    copyright,
    children,
    showFooter = true,
  } = props;

  return (
    <main>
      <SEO title={pageTitle} />
      <article>
        {children}
      </article>
      {
        showFooter
          ? (
            <footer className={footer}>
              <section className={contactContainer}>
                <section className={address}>
                  <section className={contact}>
                    <a href="https://goo.gl/maps/7wTcdq9sKpjooPus7" target="_blank" rel="noreferrer">
                      Smedestraat 27<br />
                      2011 RE Haarlem
                    </a>
                  </section>
                </section>
                <section className={socialContainer}>
                  <a href="https://www.instagram.com/shibuya_haarlem/" target="_blank" rel="noreferrer" className={social}>
                    <Instagram width={18} height={18} />
                    Instagram
                  </a>
                </section>
              </section>
              <p className={copy}>
                {copyright}
              </p>
            </footer>
          )
          : null
      }
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
            (function (d, s, id, h) { var ftjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; var js = d.createElement(s); js.id = id; js.src = "https://cdn.formitable.com/sdk/v1/ft.sdk.min.js"; h && (js.onload = h); ftjs.parentNode.insertBefore(js, ftjs); }(document, 'script', 'formitable-sdk', function () { FT.load('Analytics'); }));
           `,
        }}
      />
      <div className="ft-widget-b2" data-restaurant="bb2a45f9" data-open="1500" data-open-mobile="1500" data-color="#D13A36" data-language="auto" data-tag="Website" data-toolbar="true" data-toolbar-mobile="true" />
    </main>
  );
};

Layout.propTypes = propTypes;

export default Layout;
